export default __webpack_public_path__ + "static/media/label_shared.8b767a10.svg";